var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUndrawWishlist0K5W(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800.124,
    height: 801.932,
    viewBox: "0 0 800.124 801.932",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-560 -139)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M450.334,441.755l9.538,37.691-65.86-.813,7.537-34.438Z",
    transform: "translate(789.236 163.653)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.962,508.605l14.3,62.558,26.318,125.249-12.2,2.439L371.553,512.18Z",
    transform: "translate(824.791 225.574)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.392,530.734,461.98,589.219,423.193,706.731l-16.262-4.065L442.085,500.1Z",
    transform: "translate(735.83 217.694)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.059,454.884s29.4,55.009,24.042,115.774c0,0-43.35,34.873-112.989,2.592l28.667-121.53Z",
    transform: "translate(773.35 172.883)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.465,626.361a5.434,5.434,0,0,0,2.246-3.809c.1-1.578-.677-3.272-2.318-5.033-.039-.507-.549-6.786-1.684-7.911.1-.336.673-2.565-.274-4.012a2.748,2.748,0,0,0-2.139-1.181l-.042,0-.021.037c-.027.049-2.789,4.907-6.944,5.333-2.382.245-4.767-1-7.088-3.689-.083-.2-.739-3.479-1.163-5.65l-.017-.087L385.383,612.4l-13.233,3.708a3.917,3.917,0,0,0-.642,7.274l6.414,3.122a19.862,19.862,0,0,0,8.642,1.994h34.792a9.64,9.64,0,0,0,6.108-2.141Z",
    transform: "translate(866.941 310.56)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.579,626.361a5.434,5.434,0,0,0,2.246-3.809c.1-1.578-.677-3.272-2.318-5.033-.039-.507-.549-6.786-1.684-7.911.1-.336.673-2.565-.274-4.012a2.748,2.748,0,0,0-2.139-1.181l-.042,0-.021.037c-.027.049-2.789,4.907-6.944,5.333-2.382.245-4.767-1-7.088-3.689-.083-.2-.739-3.479-1.163-5.65l-.017-.087L452.5,612.4l-13.233,3.708a3.917,3.917,0,0,0-.642,7.274l6.414,3.122a19.862,19.862,0,0,0,8.642,1.994h34.792a9.64,9.64,0,0,0,6.108-2.141Z",
    transform: "translate(670.547 310.56)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.006,393.809a26.565,26.565,0,1,0-34.523,25.35l5.135,33.939,26.18-21.816a65.949,65.949,0,0,1-8.689-15.327A26.536,26.536,0,0,0,457.006,393.809Z",
    transform: "translate(773.102 94.637)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614,468.822l-5.677-5.121c-20.158-18.508-33.467-30.52-33.467-45.484a21.288,21.288,0,0,1,21.529-21.66A23.156,23.156,0,0,1,614,404.828a23.156,23.156,0,0,1,17.615-8.27,21.288,21.288,0,0,1,21.529,21.66c0,14.964-13.308,26.976-33.467,45.484Z",
    transform: "translate(555.043 1111.742) rotate(-69)",
    fill: "#F50057"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.058,394.649l-31.288,20-14.442,25.5a35.677,35.677,0,0,0-3.983,24.35l6.635,34.327h69.182l-10.931-71.617A60.214,60.214,0,0,0,446.056,401.8l-5-7.149Z",
    transform: "translate(788.334 120.021)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.131,430.768s-1.24,9.411-12.733,9.719l-23.313.623s19.708-47.962,11.6-42.558S411.975,381.3,411.975,381.3L405.6,393.261s-15.233-5.516,1.649-19.024c0,0,20.143-15.573,41.528-6.221s17.355,62.752,17.355,62.752Z",
    transform: "translate(772.506 92.581)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.6,500.164l.559-25.744-15.031-.326-.558,25.744a15.781,15.781,0,0,0-4.755,11.235c-.174,8.025,5.068,14.647,11.71,14.791s12.166-6.244,12.34-14.269a15.781,15.781,0,0,0-4.263-11.43Z",
    transform: "translate(799.436 193.608)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.243,420.738V545.521h26.1l7.715-123.73",
    transform: "translate(803.043 144.186)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-171.701 -0.97)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M665.294,269.316h-4.4V148.89a69.7,69.7,0,0,0-69.7-69.7H336.062a69.7,69.7,0,0,0-69.7,69.7V809.551a69.7,69.7,0,0,0,69.7,69.7H591.2a69.7,69.7,0,0,0,69.7-69.7V355.035h4.4Z",
    transform: "translate(546 60.78)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.274,95.686h-33.3a24.729,24.729,0,0,1-22.9,34.069H389.9A24.729,24.729,0,0,1,367,95.686H335.9a52.051,52.051,0,0,0-52.051,52.051V807.429a52.051,52.051,0,0,0,52.05,52.05H592.264a52.051,52.051,0,0,0,52.051-52.051V147.737a52.051,52.051,0,0,0-52.039-52.051Z",
    transform: "translate(547.746 62.421)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M967.383,196.047H842.7a4.069,4.069,0,1,1,0-8.137H967.383a4.069,4.069,0,0,1,0,8.137Z",
    transform: "translate(-50.075 93.99)",
    fill: "#F50057"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M896.746,215.419H842.7a4.069,4.069,0,0,1,0-8.137h54.049a4.069,4.069,0,1,1,0,8.137Z",
    transform: "translate(-50.075 90.683)",
    fill: "#F50057"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(312.575 -238.16)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16.161,
    cy: 16.161,
    r: 16.161,
    transform: "translate(630 516)",
    fill: "#F50057"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.064,593.129h-.1a2.113,2.113,0,0,1-1.56-.813l-2.7-3.467a2.115,2.115,0,0,1,.371-2.968l.1-.076a2.113,2.113,0,0,1,2.968.371,1.541,1.541,0,0,0,2.335.114l5.48-5.8a2.117,2.117,0,0,1,2.989-.081l.09.085a2.113,2.113,0,0,1,.081,2.989l-8.51,8.982a2.112,2.112,0,0,1-1.534.661Z",
    transform: "translate(-206.586 -55.16)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-71.638 36.001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M612.319,624.3h-43a9.511,9.511,0,0,1-9.5-9.5v-27a9.511,9.511,0,0,1,9.5-9.5h43a9.511,9.511,0,0,1,9.5,9.5v27a9.511,9.511,0,0,1-9.5,9.5Z",
    transform: "translate(217.181 -343.295)",
    fill: "#F50057"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.819,426.034l-2.315-2.089c-8.223-7.549-13.651-12.449-13.651-18.553a8.683,8.683,0,0,1,8.782-8.835,9.445,9.445,0,0,1,7.185,3.374A9.445,9.445,0,0,1,598,396.557a8.683,8.683,0,0,1,8.782,8.835c0,6.1-5.429,11-13.651,18.553Z",
    transform: "translate(217.148 -153.557)",
    fill: "#f2f2f2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M967.383,196.047H842.7a4.069,4.069,0,1,1,0-8.137H967.383a4.069,4.069,0,0,1,0,8.137Z",
    transform: "translate(-50.075 179.99)",
    fill: "#F50057"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M896.746,215.419H842.7a4.069,4.069,0,0,1,0-8.137h54.049a4.069,4.069,0,1,1,0,8.137Z",
    transform: "translate(-50.075 176.683)",
    fill: "#F50057"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(312.575 -152.16)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16.161,
    cy: 16.161,
    r: 16.161,
    transform: "translate(630 516)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.064,593.129h-.1a2.113,2.113,0,0,1-1.56-.813l-2.7-3.467a2.115,2.115,0,0,1,.371-2.968l.1-.076a2.113,2.113,0,0,1,2.968.371,1.541,1.541,0,0,0,2.335.114l5.48-5.8a2.117,2.117,0,0,1,2.989-.081l.09.085a2.113,2.113,0,0,1,.081,2.989l-8.51,8.982a2.112,2.112,0,0,1-1.534.661Z",
    transform: "translate(-206.586 -55.16)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-71.638 122.001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M612.319,624.3h-43a9.511,9.511,0,0,1-9.5-9.5v-27a9.511,9.511,0,0,1,9.5-9.5h43a9.511,9.511,0,0,1,9.5,9.5v27a9.511,9.511,0,0,1-9.5,9.5Z",
    transform: "translate(217.181 -343.295)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.819,426.034l-2.315-2.089c-8.223-7.549-13.651-12.449-13.651-18.553a8.683,8.683,0,0,1,8.782-8.835,9.445,9.445,0,0,1,7.185,3.374A9.445,9.445,0,0,1,598,396.557a8.683,8.683,0,0,1,8.782,8.835c0,6.1-5.429,11-13.651,18.553Z",
    transform: "translate(217.148 -153.557)",
    fill: "#F50057"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M967.383,196.047H842.7a4.069,4.069,0,1,1,0-8.137H967.383a4.069,4.069,0,0,1,0,8.137Z",
    transform: "translate(-50.075 265.99)",
    fill: "#F50057"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M896.746,215.419H842.7a4.069,4.069,0,0,1,0-8.137h54.049a4.069,4.069,0,1,1,0,8.137Z",
    transform: "translate(-50.075 262.683)",
    fill: "#F50057"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(312.575 -66.16)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16.161,
    cy: 16.161,
    r: 16.161,
    transform: "translate(630 516)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.064,593.129h-.1a2.113,2.113,0,0,1-1.56-.813l-2.7-3.467a2.115,2.115,0,0,1,.371-2.968l.1-.076a2.113,2.113,0,0,1,2.968.371,1.541,1.541,0,0,0,2.335.114l5.48-5.8a2.117,2.117,0,0,1,2.989-.081l.09.085a2.113,2.113,0,0,1,.081,2.989l-8.51,8.982a2.112,2.112,0,0,1-1.534.661Z",
    transform: "translate(-206.586 -55.16)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-71.638 208.001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M612.319,624.3h-43a9.511,9.511,0,0,1-9.5-9.5v-27a9.511,9.511,0,0,1,9.5-9.5h43a9.511,9.511,0,0,1,9.5,9.5v27a9.511,9.511,0,0,1-9.5,9.5Z",
    transform: "translate(217.181 -343.295)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.819,426.034l-2.315-2.089c-8.223-7.549-13.651-12.449-13.651-18.553a8.683,8.683,0,0,1,8.782-8.835,9.445,9.445,0,0,1,7.185,3.374A9.445,9.445,0,0,1,598,396.557a8.683,8.683,0,0,1,8.782,8.835c0,6.1-5.429,11-13.651,18.553Z",
    transform: "translate(217.148 -153.557)",
    fill: "#F50057"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M967.383,196.047H842.7a4.069,4.069,0,1,1,0-8.137H967.383a4.069,4.069,0,0,1,0,8.137Z",
    transform: "translate(-50.075 351.99)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M896.746,215.419H842.7a4.069,4.069,0,0,1,0-8.137h54.049a4.069,4.069,0,1,1,0,8.137Z",
    transform: "translate(-50.075 348.683)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(312.575 19.84)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16.161,
    cy: 16.161,
    r: 16.161,
    transform: "translate(630 516)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.064,593.129h-.1a2.113,2.113,0,0,1-1.56-.813l-2.7-3.467a2.115,2.115,0,0,1,.371-2.968l.1-.076a2.113,2.113,0,0,1,2.968.371,1.541,1.541,0,0,0,2.335.114l5.48-5.8a2.117,2.117,0,0,1,2.989-.081l.09.085a2.113,2.113,0,0,1,.081,2.989l-8.51,8.982a2.112,2.112,0,0,1-1.534.661Z",
    transform: "translate(-206.586 -55.16)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-71.638 294.001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M612.319,624.3h-43a9.511,9.511,0,0,1-9.5-9.5v-27a9.511,9.511,0,0,1,9.5-9.5h43a9.511,9.511,0,0,1,9.5,9.5v27a9.511,9.511,0,0,1-9.5,9.5Z",
    transform: "translate(217.181 -343.295)",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M967.383,196.047H842.7a4.069,4.069,0,1,1,0-8.137H967.383a4.069,4.069,0,0,1,0,8.137Z",
    transform: "translate(-50.075 437.99)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M896.746,215.419H842.7a4.069,4.069,0,0,1,0-8.137h54.049a4.069,4.069,0,1,1,0,8.137Z",
    transform: "translate(-50.075 434.683)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(312.575 105.84)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16.161,
    cy: 16.161,
    r: 16.161,
    transform: "translate(630 516)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.064,593.129h-.1a2.113,2.113,0,0,1-1.56-.813l-2.7-3.467a2.115,2.115,0,0,1,.371-2.968l.1-.076a2.113,2.113,0,0,1,2.968.371,1.541,1.541,0,0,0,2.335.114l5.48-5.8a2.117,2.117,0,0,1,2.989-.081l.09.085a2.113,2.113,0,0,1,.081,2.989l-8.51,8.982a2.112,2.112,0,0,1-1.534.661Z",
    transform: "translate(-206.586 -55.16)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-71.638 380.001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M612.319,624.3h-43a9.511,9.511,0,0,1-9.5-9.5v-27a9.511,9.511,0,0,1,9.5-9.5h43a9.511,9.511,0,0,1,9.5,9.5v27a9.511,9.511,0,0,1-9.5,9.5Z",
    transform: "translate(217.181 -343.295)",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M967.383,196.047H842.7a4.069,4.069,0,1,1,0-8.137H967.383a4.069,4.069,0,0,1,0,8.137Z",
    transform: "translate(-50.075 523.99)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M896.746,215.419H842.7a4.069,4.069,0,0,1,0-8.137h54.049a4.069,4.069,0,1,1,0,8.137Z",
    transform: "translate(-50.075 520.683)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(312.575 191.84)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16.161,
    cy: 16.161,
    r: 16.161,
    transform: "translate(630 516)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.064,593.129h-.1a2.113,2.113,0,0,1-1.56-.813l-2.7-3.467a2.115,2.115,0,0,1,.371-2.968l.1-.076a2.113,2.113,0,0,1,2.968.371,1.541,1.541,0,0,0,2.335.114l5.48-5.8a2.117,2.117,0,0,1,2.989-.081l.09.085a2.113,2.113,0,0,1,.081,2.989l-8.51,8.982a2.112,2.112,0,0,1-1.534.661Z",
    transform: "translate(-206.586 -55.16)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-71.638 466.001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M612.319,624.3h-43a9.511,9.511,0,0,1-9.5-9.5v-27a9.511,9.511,0,0,1,9.5-9.5h43a9.511,9.511,0,0,1,9.5,9.5v27a9.511,9.511,0,0,1-9.5,9.5Z",
    transform: "translate(217.181 -343.295)",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M800.124,601.191a1.868,1.868,0,0,1-1.871,1.871H1.871a1.871,1.871,0,0,1,0-3.741H798.254A1.868,1.868,0,0,1,800.124,601.191Z",
    transform: "translate(560 337.871)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M967.383,196.047H842.7a4.069,4.069,0,1,1,0-8.137H967.383a4.069,4.069,0,0,1,0,8.137Z",
    transform: "translate(-50.075 609.99)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M896.746,215.419H842.7a4.069,4.069,0,0,1,0-8.137h54.049a4.069,4.069,0,1,1,0,8.137Z",
    transform: "translate(-50.075 606.683)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(312.575 277.84)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16.161,
    cy: 16.161,
    r: 16.161,
    transform: "translate(630 516)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.064,593.129h-.1a2.113,2.113,0,0,1-1.56-.813l-2.7-3.467a2.115,2.115,0,0,1,.371-2.968l.1-.076a2.113,2.113,0,0,1,2.968.371,1.541,1.541,0,0,0,2.335.114l5.48-5.8a2.117,2.117,0,0,1,2.989-.081l.09.085a2.113,2.113,0,0,1,.081,2.989l-8.51,8.982a2.112,2.112,0,0,1-1.534.661Z",
    transform: "translate(-206.586 -55.16)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-71.638 552.001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M612.319,624.3h-43a9.511,9.511,0,0,1-9.5-9.5v-27a9.511,9.511,0,0,1,9.5-9.5h43a9.511,9.511,0,0,1,9.5,9.5v27a9.511,9.511,0,0,1-9.5,9.5Z",
    transform: "translate(217.181 -343.295)",
    fill: "#e6e6e6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawWishlist0K5W);
export default __webpack_public_path__ + "static/media/undraw_wishlist_0k5w.a3f6003d52d953a7ed2dd3a0ee613d5a.svg";
export { ForwardRef as ReactComponent };